export default "__VITE_ASSET__CqRwk4yx__"